// extracted by mini-css-extract-plugin
module.exports = {"warning":"DuplicateIdsWarning_warning__CM6XG"};